import apiClient from './api-client';

const get = endpoint => () => apiClient.get(endpoint);
const post = endpoint => data => apiClient.post(endpoint, data);

export const getTotalBalance = get('total_usd_balance');
export const getUserTotalBalance = get('total_usd_balance');
export const getSendAmount = get('sentAmount');
export const getReceiveAmount = get('receivedAmount');
export const getUsdFee = get('USDC_price');
export const getUsdtFee = get('USDT_price');
export const getEthFee = get('eth_price');
export const getEurFee = get('euroc_price');
export const getGbpFee = get('gbpt_price');
export const getJypFee = get('jpyc_price');
export const getMatFee = get('matic_price');
export const getCtyFee = get('cty_price');
export const getPaxFee = get('PAX_price');
export const getBusdFee = get('BUSD_price');
export const getBnbFee = get('bnb_price');
export const getBTCFee = get('BTC_price');
export const getApprover = get('users');
export const getBeneficiaryName = post('search_name');
export const transferInternalBalance = post('transferInternalBalance');
export const approveExternalWalletOtp = otp => apiClient.post('verifyOtpExternalWallet', { otp });
export const approveSenExternalWalletOtp = otp => apiClient.post('sendTokenExternalGasCalculation', { otp });
export const calculateAdminCommissions = post('calculateAdminCommissions');
export const byPassFee = post('byPassFee');
export const getInternalTransferHistory = post('getInternalTransferHistory');
export const listFee = get('listFee ');
export const getTransactionDetails = post('admin/getTransactionDetails');
export const editFee = post('editFee');
export const addFee = post('addFee ');
